import {
  Validator
} from "vee-validate";
import {
  BasicSelect
} from "vue-search-select";
import CryptoJS from "crypto-js";
import VueElementLoading from "vue-element-loading";
import Loader from "../../../../shared/components/loader";
import CONSTANT from "./../../../../shared/constants/constant";
import DatePicker from "vue2-datepicker";
import CustomExpandableTable from "../../../../shared/components/customExpandableTable";
import Pagination from "./../../../../shared/components/pagination";
import moment from "moment";
import Util from "./../../../../shared/util/util";
import TripServices from "../../../services/firstAndLastmilemanagement.service";
import Treeselect from '@riophae/vue-treeselect';


export default {
  name: "UADCutoffs",
  components: {
    BasicSelect,
    VueElementLoading,
    DatePicker,
    moment,
    CustomExpandableTable,
    Pagination,
    Loader,
    Treeselect
  },
  data() {
    return {
      shipmentstatuslist:[{
        value : "markuad",
        text : 'Marked'
      },{
        value : "unmarkuad",
        text : 'Unmarked'
      }],
      shipmentStatus:"",
      selectedshipmentstatus:{value:'',text:''},
      tableColumn: [
        "Shipping ID",
        "Consignee phone",
        "Consignee e-mail",
        "Delivery Pincode",
        "Delivery Address",
        "Delivery Date",
        "RAD Inscan",
        "UAD Status",
        "Action"
      ],
      innerTableColumn: ["Assigned Zones"],
      tableItems: [],
      ShipmentPhaseArr: [{
        value: "LastMile",
        text: "LastMile"
      }],
      ReasonArr: [],
      isLoading: false,
      isModalLoading: false,
      CaseArr: [],
      SubReasonArr: [],
      FiltersArr: [],
      toDate: "",
      reason: null,
      fromDate: "",
      Filters: "",
      reasonType: "",
      subreason: "",
      ShipmentPhase: "LastMile",
      Case: "",
      selectedShipmentPhase: {
        value: "",
        text: ""
      },
      selectedCase: {
        value: "",
        text: ""
      },
      selectedFilters: {
        value: "",
        text: ""
      },
      selectedSubReason: {
        value: '',
        text: ''
      },
      selectedReason: {
        value: "",
        text: ""
      },
      showmarkUAD: false,
      offset: 0,
      // offset2:0,
      pageLimit: 50,
      totalPage: 0,
      totalCount: 0,
      currentPage: 1,
      AWB: "",
      UadboxAWB: "",
      UadboxRadcutoff: "",
      UadboxUadcutoff: "",
      Uadboxtotalmps: "",
      Uadboxchargedweight: "",
      mainreasonarr: [],
      reasoncode: "",
      subreasoncode: '',
      isreasonfuturedate: '',
      issubreasonfuturedate: '',
      uadrescheduledate: '',
      originaldeliverydate : '',
      clientname : '',
      uadid : '',
      uadrescheduleerr: '',
      reasonerr: '',
      hassubreason: '',
      subreasonerr: '',
      consigneeemailid: '',
      consigneenamee: '',
      consigneephone: '',
      tableoffset: 0,
      // dateerr: false,
      uadmarkedcount : '',
      RADInscan : "",
      inputboxdisable: false,
      subreasondisable: false,
      datetexterr: '',
      consigneemax: 0,
      operationmax: 0,
      disabled: false,
      mindate: '',
      reasondata :"P111",
      reasondata1 :"P107",
      reasondata2:"P159",
      defaultHubId : '',
      forcemajuremax:0,
      processcode:''
    };
  },
  computed: {},
  async mounted() {
    var userdetailEncrypt = window.localStorage.getItem(
      "cargoAutoaccessuserdata"
    );
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), "Key");
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.defaultHubId = userdetail.hubID
    this.hubid = userdetail.hubID[0];
    this.useremail = userdetail.email;
    this.userid = parseInt(userdetail.userid);
    // this.userrole = parseInt(userdetail.userrole);
    this.userrole = userdetail.rolename[0];
    this.isLoading = true;
    // this.showmarkUAD=true
    await this.getShipmentListing();
    await Promise.all[this.uadReasonfunction(this.reasondata), this.uadReasonfunction(this.reasondata1),
      this.uadReasonfunction(this.reasondata2)]
    this.mindate = moment().tz('Asia/Kolkata').add(1, 'days').format('YYYY-MM-DD');
  },
  methods: {
    selectshipmentStatus(data) {
      this.selectedshipmentstatus = data;
      this.shipmentStatus = data.value;
    },
    searchShipment() {
      this.currentPage = 1;
      this.offset = 0;
      this.tableoffset = 0;
      this.getShipmentListing();
    },
    async getShipmentListing() {
      try {
        this.isLoading = true;
        this.tableItems = [];
        this.totalCount = 0;
        let inputPayload = {
          // hubid: 212,
          hubid: this.hubid,
          lastmodifiedby: this.useremail,
          offset: this.offset == 0 ? 1 : this.offset,
          limit: this.pageLimit,
          type: 'LastMile',
        };
        if (this.AWB) {
          inputPayload.ParentAWB = this.AWB;
        }
        if (this.fromDate) {
          inputPayload.FromDate = this.fromDate;
        }
        if (this.toDate) {
          inputPayload.ToDate = this.toDate;
        }
        if (this.shipmentStatus) {
          inputPayload.shipmentstatus = this.shipmentStatus;
        }
        if (this.fromDate && this.toDate) {
          if (this.fromDate > this.toDate) {
            // this.dateerr = false;
            this.datetexterr = `To Date cannot be lesser than From date.`
            this.isLoading = false;
            return false
          }
        }
        let result = await TripServices.UADShipmentListing(inputPayload);
        if (result.data.code == 200) {
          this.datetexterr = ''
          this.totalCount = Number(result.data.data.count);
          if (this.totalCount > 0) {
            this.tableItems = result.data.data.rows.map((el) => {
              return {
                "ShippingID": el.awbnumber,
                "Consigneephone": el.consigneephone,
                "Consigneeemail": el.consigneeemail,
                "DeliveryPincode": el.deliverypincode,
                "DeliveryAddress": el.deliveryaddress,
                "DeliveryDate": el.deliverydate ? moment(el.deliverydate).tz('Asia/Kolkata').format('DD-MM-YYYY') : '',
                "RADInscan": el.raddate ? moment(el.raddate).tz('Asia/Kolkata').format('YYYY-MM-DD HH:mm:ss') : '',
                "UADStatus": el.uadstatus==1 ? 'Yes' : 'No',
                "UADMarkedCount":Number(el.consigneeuadcount)+Number(el.operationuadcount)+Number(el.forcemajureuadcount),
                "valid": el.valid,
                "dropname": el.dropname,
                "rescheduledate": el.rescheduledate ? moment(el.rescheduledate).tz('Asia/Kolkata').format('DD-MM-YYYY') : '',
                "alreadyassign": el.alreadyassign,
                "tripid": el.tripid == null ? "" : el.tripid,
                "completebooking": el.completebooking,
                "uadreasonmaxedout": el.uadreasonmaxedout,
                "radcutoff": el.radcutoff,
                "uadcutoff": el.uadcutoff,
                "totalmps": el.totalmps,
                "chargedweight": el.chargedweight,
                "uadoperationmax": el.uadoperationmax,
                "uadconsigneemax": el.uadconsigneemax,
                "uadforcemajuremax":el.uadforcemajuremax,
                "originaldeliverydate" : el.originaldate,
                "clientname":el.clientname
              };
            });
          } else {
            this.tableItems = [];
          }
        }
        if (this.totalCount < this.pageLimit) {
          this.totalPage = 1;
        } else {
          this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
        }
        this.isLoading = false;
      } catch (err) {
        console.log(err);
        await this.getShipmentListing();
        this.isLoading = false;
      }
    },
    async senduademail() {
      try {
        let inputPayload = {
          hubid: this.defaultHubId,
          id : this.uadid.toString(),
          awb: this.UadboxAWB,
          consigneeemail: this.consigneeemailid,
          consigneename: this.consigneenamee,
          consigneephone: this.consigneephone,
          templatekey: "2",
          rescheduledate: this.uadrescheduledate,
          reason: this.reason
        };
        let result = await TripServices.SendUADEmail(inputPayload);
        if (result.data.code == 200) {
        } else {
          this.$alertify.error(result.data.message);
        }
        this.isLoading = false;
      } catch (err) {
        console.log(err);
        this.isLoading = false;
      }
    },
    async uadReasonfunction(reasoncode) {
      try {
        this.ReasonArr = []
        this.inputboxdisable = false
        this.subreasondisable = false
        this.isModalLoading = true;
        this.reason = null;
        this.subreason = null;
        this.uadrescheduledate = ""
        this.reasonerr = ""
        this.subreasonerr = ""
        this.uadrescheduleerr = ""

        let inputPayload = {
          operationflag: reasoncode,
        };
        let result = await TripServices.GetUADReason(inputPayload);
        if (result.data.code == 200) {
          result.data.data.forEach(el => {
            if(reasoncode == 'P111'){
              this.disabled = this.consigneemax == 1 ?  true : false 
              this.processcode = reasoncode         
            }
            else if(reasoncode == 'P107'){
              this.disabled = this.operationmax == 1 ?  true : false
              this.processcode = reasoncode         
            }else if(reasoncode == 'P159'){
              this.disabled = this.forcemajuremax == 1 ?  true : false
              this.processcode = reasoncode         
            }
            this.ReasonArr.push({
              "text": el.title,
              "id": el.title,
              "label": el.title,
              "value": el.title,
              "hassubreason": el.hasSubStatus == null ? false : el.hasSubStatus,
              "key": el.substatusKey,
              "subreasonarr": el,
              "reasoncode": el.uniquecode,
              "isreasonreschedule": el.IsFutureDate,
              "uadtype" : this.processcode,
              "isDisabled": this.disabled
            })
          })
        } else {
          this.$alertify.error(result.data.message);
        }
        this.isModalLoading = false;
      } catch (err) {
        console.log(err);
        this.isModalLoading = false;
      }
    },
    async reasonselect(data) {
      this.isModalLoading = true;
      this.selectedReason.text = ''
      this.selectedReason.value = ''
      this.subreason = null
      this.uadrescheduledate = ""
      this.reasonerr = ''
      this.SubReasonArr = []
      this.selectedReason.text = data.text
      this.selectedReason.value = data.value
      this.reasoncode = data.reasoncode
      this.reason = data.value
      this.reasonType = data.uadtype
      this.hassubreason = data.hassubreason
      this.isreasonfuturedate = data.isreasonreschedule
      this.subreasondisable = data.hassubreason == true ? false : true;
      this.inputboxdisable = data.isreasonreschedule == true ? false : true;
      this.isModalLoading = false;
      this.result = data.subreasonarr[data.key]
      if (data.hassubreason == true) {
        this.result.forEach(el => {
          this.SubReasonArr.push({
            "id": el.title,
            "label": el.title,
            "text": el.title,
            "value": el.title,
            "subreasoncode": el.uniquecode,
            "issubreasonfuturedate": el.IsFutureDate,
          })
        })
      }
    },
    async selectSubReason(data) {
      this.selectedSubReason.text = data.value
      this.selectedSubReason.value = data.value
      this.subreason = data.value
      this.subreasoncode = data.subreasoncode
      this.issubreasonfuturedate = data.issubreasonfuturedate
      this.subreasonerr = ''
      this.isreasonfuturedate = data.issubreasonfuturedate 
      this.inputboxdisable = data.issubreasonfuturedate == true ? false : true;
    },

    async markuad() {
      try {
        if (this.checkErr()) {
          return false
        }
        this.isModalLoading = true;
        let inputPayload = {
          parentAWB: this.UadboxAWB,
          uadtype: this.reasonType,
          reason: this.reason,
          reasoncode: this.reasoncode,
          subreason: this.subreason,
          subreasoncode: this.subreasoncode,
          rescheduledate: this.uadrescheduledate,
          lastmodifiedby: this.useremail,
          hubid: this.hubid,
          radcutoff: this.UadboxRadcutoff,
          uadcutoff: this.UadboxUadcutoff,
          totalmps: this.Uadboxtotalmps,
          chargewt: this.Uadboxchargedweight,
          consigneename : this.consigneenamee,
          raddate : this.RADInscan !='' ? moment(this.RADInscan).tz('Asia/Kolkata').format('YYYY-MM-DD'): null,
          clientname : this.clientname,
          uadmarkedcount : this.uadmarkedcount,
          originaldate : this.originaldeliverydate == null ? moment().tz('Asia/Kolkata').format('DD-MM-YYYY') : this.originaldeliverydate
        };
        let result = await TripServices.MarkUAD(inputPayload);
        if (result.data.code == 200) {
          this.uadid = result.data.data
          this.$alertify.success(result.data.message)
          if (inputPayload.uadtype == "P111") {
            await this.senduademail()// temporarily disabled, to enable change the process code in above line from p106 to p111
          }
          this.closeMarkUAD()
          this.getShipmentListing();
        } else {
          this.$alertify.error(result.data.message)
        }
        this.isModalLoading = false;
      } catch (err) {
        console.log(err);
        this.isModalLoading = false;
      }
    },
    checkErr() {
      let err = false
      if (this.reason == null) {
        err = true
        this.reasonerr = 'Please select reason'
      }
      if ((this.isreasonfuturedate == true ) && this.uadrescheduledate == "") {
        err = true
        this.uadrescheduleerr = 'Re-Schedule date is mandatory for this Reason/Sub-reason'
      }
      if (this.hassubreason == true && this.subreason == null) {
        err = true
        this.subreasonerr = 'Please select Sub-Reason'
      }
      if (this.uadrescheduledate != "") {
        let dt = moment().tz("Asia/Kolkata").format('YYYY-MM-DD');
        if (dt >= this.uadrescheduledate) {
          err = true
          this.uadrescheduleerr = `Re-Schedule date should be greater than today's date`
        }
      }
      return err
    },
    onSubmitSearch() {
      this.searchShipment();
    },
    onPageChange(page) {
      this.isAllSelected = false;
      this.currentPage = page;
      this.offset = (page - 1) * this.pageLimit
      this.tableoffset = (page - 1) * this.pageLimit
      this.offset = this.offset + 1
      this.getShipmentListing();
    },

    clearForm() {
      this.currentPage = 1;
      this.offset = 0;
      this.AWB = ''
      this.fromDate = ''
      this.toDate = ''
      this.ClientName = null
      this.pickupPincode = ''
      this.datetexterr = ''
      this.shipmentStatus = '',
      this.selectedshipmentstatus = {}
      this.onPageChange(1)
    },

    showmarkuad(awb, email, name, phone, radcutoff, uadcutoff, totalmps, chargewt,uadconsigneemax,uadoperationmax,uadforcemajuremax,raddate,originaldate,clientname,uadmarkedcount) {
      this.showmarkUAD = true
      this.UadboxAWB = awb,
      this.uadReasonfunction(this.reasondata)
      this.uadReasonfunction(this.reasondata1)
      this.uadReasonfunction(this.reasondata2)
      this.UadboxRadcutoff = radcutoff,
      this.uadmarkedcount = uadmarkedcount
      this.UadboxUadcutoff = uadcutoff,
      this.Uadboxtotalmps = totalmps,
      this.Uadboxchargedweight = chargewt,
      this.RADInscan = raddate
      this.consigneeemailid = email
      this.consigneenamee = name
      this.consigneephone = phone
      this.operationmax = uadoperationmax
      this.consigneemax = uadconsigneemax
      this.forcemajuremax = uadforcemajuremax
      this.originaldeliverydate = originaldate
      this.clientname = clientname
      this.selectedSubReason = {
        value: '',
        text: ''
      }
      this.selectedReason = {
        value: '',
        text: ''
      }

    },
    closeMarkUAD() {
      this.showmarkUAD = false
      this.reasondata = "P111",
      this.reasondata1 = "P107",
      this.reasondata2 = "P159",
      this.uadmarkedcount = ''
        // this.getuadreason()
        // this.getuadreason1()
      this.UadboxAWB = "",
        this.UadboxRadcutoff = "",
        this.clientname = ""
        this.UadboxUadcutoff = "",
        this.Uadboxtotalmps = "",
        this.Uadboxchargedweight = "",
        this.originaldeliverydate = '',
        this.uadid = '',
        this.RADInscan = "",
        this.reason = null
      this.subreason = null
      this.selectedSubReason = {
          value: '',
          text: ''
        },
        this.selectedReason = {
          value: '',
          text: ''
        },
        this.uadrescheduledate = "",
        this.issubreasonfuturedate = "",
        this.isreasonfuturedate = "",
        this.hassubreason = "",
        this.subreasonerr = "",
        this.uadrescheduleerr = "",
        this.reasonerr = "",
        this.consigneeemailid = "",
        this.consigneenamee = "",
        this.consigneephone = "",
        this.inputboxdisable = false
      this.subreasondisable = false
    },
    selectShipmentPhase() {},
    selectCase() {},
    selectFilters() {},
  },
};



// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/configuration/shipmentSearch/shipmentSearch.component.js